import { logout as _logout, submitOpcLogoutFormRequest } from '~/api/auth';
import AuthenticationStore from '~/auth/authenticationStore';
import {
  redirectToDomainLogin,
  redirectToLogin,
  redirectToLoginEmbed,
} from '~/services/redirects';

const AS = AuthenticationStore();

export const logout = async (currentUser: {
  client_config?: { sub_domain?: string | null } | null;
}) => {
  const { client_config: clientConfig } = currentUser;
  const subDomain = clientConfig?.sub_domain;

  try {
    const response = await _logout();
    if (
      response?.workday_logout_url &&
      response?.id_token_hint &&
      response?.oidc_client_id
    ) {
      AS.clearAuthentication();

      submitOpcLogoutFormRequest({
        action: response.workday_logout_url,
        id_token_hint: response.id_token_hint,
        oidc_client_id: response.oidc_client_id,
      });

      return; // Early return - form submission will navigate away
    }
  } catch (error) {
    // _logout() failed, but we still want to do the fallback redirect
    console.error('Logout API failed:', error);
  }

  // Fallback redirect logic (only runs if no redirect_url or logout failed)
  AS.clearAuthentication();

  if (AS.isEmbed()) {
    redirectToLoginEmbed();
  } else if (subDomain) {
    redirectToLogin(subDomain);
  } else {
    redirectToDomainLogin();
  }
};
